import axios, { AxiosError } from "axios"

type PydanticValidationError = {
	detail: Array<{
		type: string
		loc: (string | number)[]
		msg: string
	}>
}

export const extractApiErrorMessage = (err: unknown, defaultErrorMessage?: string): string => {
	if (axios.isAxiosError(err)) {
		const ax = err as AxiosError<PydanticValidationError>
		const msg = ax.response?.data?.detail?.[0]?.msg

		if (msg) {
			return msg
		}
		if (ax.response?.status === 422) {
			return "Validation error (422)"
		}

		return defaultErrorMessage || ax.message || "Network error"
	}
	if (err instanceof Error) {
		return err.message
	}
	return defaultErrorMessage || "Unknown error"
}
